var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInvoiceHistory = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 21,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  d: "M2.48 1.396v3.958M6.438 5.354H2.479M10 1.396A9.105 9.105 0 1 1 .896 10.5M2.495 5.354A9.08 9.08 0 0 1 10 1.396"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M8.417 12.644s0 1.254 1.761 1.254c2.206 0 2.206-3.003 0-3.447-2.206-.446-2.206-3.448 0-3.448 1.373 0 1.373 1.254 1.373 1.254M10.297 5.75v1.253M10.297 13.898v1.253"
})));
export default SvgInvoiceHistory;